// extracted by mini-css-extract-plugin
export default {"Pepper30":"#D8D8D6","Black":"#333D47","dropdownContainer":"G394c78","arrowDown":"G7193e7 G5e65f6 Gb5dd03"};